// İSG Portal — Breadcrumb (S33 planı Stage 2/4, yeni): "← Geri" bağlantılarının yerini alır
// (plan "What is wrong today" tablosu — `← İzinlere dön` → `Work permits / Pending approval /
// Cİ-2026-00417`). Henüz hiçbir sayfa tüketmiyor (ilk gerçek tüketici Slice 3 permit detayı).
// Son öğe her zaman geçerli sayfadır (`aria-current="page"`, bağlantısız); öncekiler
// `react-router-dom`'un `Link`'i ile GERÇEK gezinme sağlar (`<span onClick>` DEĞİL).

import { Link } from 'react-router-dom';
import { cn } from './cn';

export interface BreadcrumbItem {
  label: string;
  /** Verilmezse (son öğe) geçerli sayfadır — bağlantısız, `aria-current="page"`. */
  href?: string;
}

export function Breadcrumb({
  items,
  className,
}: {
  items: BreadcrumbItem[];
  className?: string;
}) {
  return (
    <nav aria-label="breadcrumb" className={cn('text-sm', className)}>
      <ol className="flex flex-wrap items-center gap-1 carbon:gap-0">
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1 carbon:gap-0">
              {index > 0 ? (
                <span className="px-1 text-muted carbon:mx-2 carbon:px-0" aria-hidden="true">
                  /
                </span>
              ) : null}
              {item.href && !last ? (
                <Link
                  to={item.href}
                  className="text-muted underline-offset-2 hover:text-fg hover:underline carbon:text-primary carbon:hover:text-primary carbon:hover:underline"
                >
                  {item.label}
                </Link>
              ) : (
                <span aria-current="page" className="text-fg">
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
